import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import KitoBuddy from '../../../components/Buddy';

import up from '../../../assets/designSystem/icons/chevron-circle/up.svg';
import down from '../../../assets/designSystem/icons/chevron-circle/down.svg';

export default function FAQs({ title, questionTitle, questions }) {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  return (
    <>
      <KitoBuddy image="asking2">{t(title)}</KitoBuddy>
      <div className="faq__content">
        <div className="faq__title">
          <p>
            <span className="moved-text">Tap for more information</span> <br />
            {t(questionTitle)}
          </p>
        </div>

        <div className="faq__options">
          {questions.map((question, index) => {
            const isOpen = openIndex === index;

            return (
              <div key={question.question}>
                <div className="faq__qstn__container">
                  <div
                    className="faq__qstn"
                    onClick={() => handleToggle(index)}
                    role="button"
                    tabIndex={0}
                  >
                    <button
                      type="button"
                      className="faq__toggle"
                      aria-expanded={isOpen}
                    >
                      <div>
                        <img
                          src={isOpen ? up : down}
                          alt={isOpen ? 'up' : 'down'}
                        />
                      </div>
                    </button>
                    <h4>{t(question.qstn)}</h4>
                  </div>
                  {isOpen && (
                    <p className="faq__answer">{t(question.answer)}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
